import api from './api';

export default function fetchSiteInfo() {
  return api('v4')
    .get('/site-info')
    .then(response => response.data);
}
